import "../../../../styles/historyDocumentsComponent.scss";

import Icon, { iconTypes } from "../../../common/components/Icon.jsx";
import { Tab, TabList, TabPanel, Tabs } from "../../../common/components/Tabs.jsx";
import { Tag, tagTypes } from "../../../common/components/Tag.jsx";

import { HISTORY_TYPES } from "../../actions/history";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import Scroll from "../../../common/components/Scroll";
import SearchBar from "../order/SearchBar.jsx";
import ShowForDeviceTypes from "../../../common/components/ShowForDeviceTypes";
import moment from "moment";
import { scssVariables } from "../../../common/util/config";

class PrintButton extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClickPrint = this.onClickPrint.bind(this);
    }

    onClickPrint() {
        const {
            result,
            downloadHistoryPdf,
        } = this.props;
        downloadHistoryPdf(result);
    }
    render() {
        return (
            <button className="btn circular" onClick={this.onClickPrint}>
                <Icon type={iconTypes.print}></Icon>
            </button>
        );
    }
}
PrintButton.propTypes = {
    downloadHistoryPdf: PropTypes.func.isRequired,
    result: PropTypes.object.isRequired,

};

class CreateClaimButton extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClickCreateClaim = this.onClickCreateClaim.bind(this);
    }

    onClickCreateClaim() {
        const {
            history,
            invoiceId,
            clearClaim,
        } = this.props;
        clearClaim();
        history.push(`/history/claim/${invoiceId}/invoice`);
    }
    render() {
        return (
            <button className="btn" onClick={this.onClickCreateClaim}>
                {this.props.localization.text("history", "createInvoice")}
            </button>
        );
    }
}
CreateClaimButton.propTypes = {
    localization: Localization.propTypes.isRequired,
    history: PropTypes.object.isRequired,
    invoiceId: PropTypes.number.isRequired,
    clearClaim: PropTypes.func.isRequired,
};

class TobaccoHistoryBag extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            bag: {
                creditedAmount,
                supplierName,
                supplierReferenceNo,
                status,
                lines,
            },
            displayBagInfo,
        } = this.props;
        return (
            <>
                {displayBagInfo && (
                    <div className="tobacco-history-documents-row">
                        <div className="tobacco-history-documents-list-item small"></div>
                        <div className="tobacco-history-documents-list-item small">{status}</div>
                        <div className="tobacco-history-documents-list-item small">{(creditedAmount && creditedAmount > 0) ? creditedAmount.toFixed(2) : ""}</div>
                        <div className="tobacco-history-documents-list-item large">{supplierName}</div>
                        <div className="tobacco-history-documents-list-item">{supplierReferenceNo}</div>
                    </div>
                )}
                {lines.map((line, idx) => (
                    <div key={idx} className="tobacco-history-documents-row">
                        <div className="tobacco-history-documents-list-item small"></div>
                        <div className="tobacco-history-documents-list-item small"></div>
                        <div className="tobacco-history-documents-list-item small"></div>
                        <div className="tobacco-history-documents-list-item large"></div>
                        <div className="tobacco-history-documents-list-item"></div>
                        <div className="tobacco-history-documents-list-item small">{line.productId}</div>
                        <div className="tobacco-history-documents-list-item large">{line.productName}</div>
                        <div className="tobacco-history-documents-list-item small">{line.epdNo}</div>
                        <div className="tobacco-history-documents-list-item small">{line.expectedQty}</div>
                        <div className="tobacco-history-documents-list-item small">{(line.creditedQty && line.creditedQty > 0) ? line.creditedQty : ""}</div>
                    </div>
                ))}
            </>
        );
    }
}

TobaccoHistoryBag.propTypes = {
    bag: PropTypes.shape({
        creditedAmount: PropTypes.number,
        customerReturnOrderId: PropTypes.number,
        supplierId: PropTypes.string,
        supplierName: PropTypes.string,
        supplierReferenceNo: PropTypes.string,
        status: PropTypes.string,
        lines: PropTypes.array
    }),
    displayBagInfo: PropTypes.bool.isRequired,
};

class TobaccoDocumentsListEntry extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

        this.toggleExpanded = (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                expanded: !this.state.expanded
            });
        };
    }

    render() {
        const { result } = this.props;

        const firstBag = result.bags.length > 0 && result.bags[0];

        return (
            <div className="tobacco-history-documents-list-item-wrapper" key={result.complaintId}>
                <div className="tobacco-history-documents-row">
                    <div className="tobacco-history-documents-list-item small">{moment(result.createdDate).format("YYYY-MM-DD")}</div>
                    <div className="tobacco-history-documents-list-item small">{firstBag.status}</div>
                    <div className="tobacco-history-documents-list-item small">{(firstBag.creditedAmount && firstBag.creditedAmount > 0) ? firstBag.creditedAmount.toFixed(2) : ""}</div>
                    <div className="tobacco-history-documents-list-item large">{firstBag.supplierName}</div>
                    <div className="tobacco-history-documents-list-item">{firstBag.supplierReferenceNo}</div>
                    <div className="tobacco-history-documents-list-item small"></div>
                    <div className="tobacco-history-documents-list-item large"></div>
                    <div className="tobacco-history-documents-list-item small"></div>
                    <div className="tobacco-history-documents-list-item small"></div>
                    <div className="tobacco-history-documents-list-item small">
                        <div className="tobacco-history-documents-list-expander"><span onClick={this.toggleExpanded}><Icon type={this.state.expanded ? iconTypes.down : iconTypes.up} /></span></div>
                    </div>
                </div>
                {this.state.expanded && result.bags.map((bag, idx) => <TobaccoHistoryBag key={idx} bag={bag} displayBagInfo={idx !== 0} />)}
            </div>
        );
    }
}

TobaccoDocumentsListEntry.propTypes = {
    result: PropTypes.object.isRequired
};

class TobaccoDocumentsList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.headerRef = React.createRef();

        this.onScroll = (scrollLeft) => {
            if (this.headerRef.current) {
                this.headerRef.current.scrollLeft = scrollLeft;
            }
        };
    }

    componentDidMount() {
        this.props.clearTobaccoDocumentHistoryQueryResults();
        this.props.editTobaccoDocumentHistoryQueryImmediately({
        });
    }

    render() {
        const {
            tobaccoDocumentsHistoryQuery: {
                results = []
            },
            localization,
            height,
        } = this.props;

        const listHeight = height - parseInt(scssVariables.productListHeaderHeight);

        return (
            <div className="tobacco-history-documents-list">
                <div ref={this.headerRef} className="tobacco-history-documents-header-wrapper">
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "date")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "complaintStatus")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "receivedSum")}</div>
                    <div className="tobacco-history-documents-list-header large">{localization.text("history", "supplier")}</div>
                    <div className="tobacco-history-documents-list-header">{localization.text("history", "supplierReferenceNo")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "productNo")}</div>
                    <div className="tobacco-history-documents-list-header large">{localization.text("history", "product")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "epd")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "returnedQty")}</div>
                    <div className="tobacco-history-documents-list-header small">{localization.text("history", "receivedQty")}</div>
                </div>
                <Scroll className="tobacco-history-documents-scroll-area" style={{ height: listHeight }} onScroll={this.onScroll}>
                    {results.map((result, idx) => (
                        <TobaccoDocumentsListEntry key={idx} result={result} />
                    ))}
                </Scroll>
            </div>
        );
    }
}

TobaccoDocumentsList.propTypes = {
    clearTobaccoDocumentHistoryQueryResults: PropTypes.func.isRequired,
    tobaccoDocumentsHistoryQuery: PropTypes.object.isRequired,
    editTobaccoDocumentHistoryQuery: PropTypes.func.isRequired,
    editTobaccoDocumentHistoryQueryImmediately: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
};

class HistoryDocumentListWrapper extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

        this.toggleExpanded = (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                expanded: !this.state.expanded
            });
        };
    }

    render() {
        const {
            clearClaim,
            downloadHistoryPdf,
            history,
            isComplaintList,
            isInvoice,
            localization,
            result,
        } = this.props;

        return (
            <div className="history-documents-list-item-wrapper">
                <div className="container">
                    <ResponsiveRows gutters={true}>
                        <ResponsiveColumn xs={4} lg={2} xl={1}>
                            <div className="history-documents-list-item history-documents-date">{moment(result.historyDate).format("YYYY-MM-DD")}</div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3} lg={2} xl={1}>
                            <div className="history-documents-list-item">{result.totalNetSum.toFixed(2)}</div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={isInvoice ? 5 : 3} sm={isComplaintList ? 2 : undefined} lg={2} xl={1}>
                            <div className="history-documents-list-item"><Tag type={tagTypes.red} label={result.historyDescription} /></div>
                        </ResponsiveColumn>
                        {isComplaintList && (
                            <ResponsiveColumn sm={2} xs={3} lg={2} xl={2}>
                                <div className="history-documents-list-item">{result.reasonForDecline}</div>
                            </ResponsiveColumn>
                        )}
                        {isComplaintList && (
                            <ResponsiveColumn sm={2} xs={3} lg={2} xl={1}>
                                <div className="history-documents-list-item">{result.complaintStatus}</div>
                            </ResponsiveColumn>
                        )}

                        {!isComplaintList && (
                            <ResponsiveColumn xs={3} lg={2} xl={1}>
                                {result.historyPdfKey &&
                                    <div className="history-documents-list-item">
                                        <PrintButton downloadHistoryPdf={downloadHistoryPdf} result={result} />
                                    </div>
                                }
                            </ResponsiveColumn>
                        )}
                        {isInvoice && (
                            <ResponsiveColumn xs={9} lg={3} xl={2}>
                                {result.invoiceId && (
                                    <div className="history-documents-claim-item">
                                        <CreateClaimButton localization={localization} history={history} invoiceId={result.invoiceId} clearClaim={clearClaim} />
                                    </div>
                                )}
                            </ResponsiveColumn>
                        )}
                        {isComplaintList && (
                            <ResponsiveColumn key="header_expand" xs={9} sm={1} lg={4} xl={6} className="expander"><div onClick={this.toggleExpanded}><Icon type={this.state.expanded ? iconTypes.down : iconTypes.up} /></div></ResponsiveColumn>
                        )}
                    </ResponsiveRows>
                    {isComplaintList && this.state.expanded && result.complaintLines && (
                        <ResponsiveRows gutters={true}>
                            {result.complaintLines.map((line, idx) => ([
                                <ResponsiveColumn xs={0} xl={5} key={`${idx}:spacer`}>
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={0} lg={0} xl={1} key={`${idx}:reasonCode`}>
                                    {line.reasonCode}
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={4} lg={2} xl={1} key={`${idx}:prd`}>
                                    <ShowForDeviceTypes xs sm md lg><label>{localization.text("history", "productNo")}:</label> </ShowForDeviceTypes>{line.productId}
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={8} lg={4} xl={2} key={`${idx}:productName`}>
                                    <ShowForDeviceTypes xs sm md lg><label>{localization.text("history", "product")}:</label> </ShowForDeviceTypes>{line.productName}
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={4} lg={2} xl={1} key={`${idx}:epd`}>
                                    <ShowForDeviceTypes xs sm md lg><label>{localization.text("history", "epd")}:</label> </ShowForDeviceTypes>{line.epdNo}
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={4} lg={2} xl={0} key={`${idx}:reasonCode`}>
                                    <ShowForDeviceTypes xs sm md lg><label>{localization.text("history", "historyDescription")}:</label> </ShowForDeviceTypes>{line.reasonCode}
                                </ResponsiveColumn>,
                                <ResponsiveColumn className="history-documents-list-item" xs={4} lg={2} xl={2} key={`${idx}:claimQtySalesunits`}>
                                    <ShowForDeviceTypes xs sm md lg><label>{localization.text("history", "claimQtySalesunits")}:</label> </ShowForDeviceTypes>{line.claimQtySalesunits}
                                </ResponsiveColumn>,
                            ]))}
                        </ResponsiveRows>
                    )}
                </div>
            </div>
        );
    }
}

HistoryDocumentListWrapper.propTypes = {
    clearClaim: PropTypes.func.isRequired,
    downloadHistoryPdf: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    isComplaintList: PropTypes.bool,
    isInvoice: PropTypes.bool,
    localization: Localization.propTypes.isRequired,
    result: PropTypes.object.isRequired,
};

export class DocumentsList extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.clearDocumentsHistoryQueryResults();
        this.props.editDocumentHistoryQueryImmediately({
            historyType: this.props.documentType
        });
    }

    render() {
        const {
            documentsHistoryQuery: {
                results = []
            },
            documentType,
            localization,
            downloadHistoryPdf,
            history,
            clearClaim,
            height,
        } = this.props;

        const listHeight = height - parseInt(scssVariables.productListHeaderHeight);

        // För complaints, dölj den oanvända PDF-kolumnen och visa istället status
        const isComplaintList = documentType === HISTORY_TYPES.CLAIMS;
        const isInvoice = documentType === HISTORY_TYPES.INVOICES;

        return (
            <div className="history-documents-list">
                <div className="history-documents-header-wrapper">
                    <ResponsiveRows gutters={true}>
                        <ResponsiveColumn xs={4} lg={2} xl={1}>
                            <div className="history-documents-list-header">{localization.text("history", "date")}</div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3} lg={2} xl={1}>
                            <div className="history-documents-list-header">{localization.text("history", "totalNetSum")}</div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3} lg={2} xl={1}>
                            <div className="history-documents-list-header">{localization.text("history", "historyDescription")}</div>
                        </ResponsiveColumn>
                        {isComplaintList && ([
                            <ResponsiveColumn className="history-documents-list-header" key="header_reasonForDecline" xs={0} lg={1} xl={2}>{localization.text("history", "reasonForDecline")}</ResponsiveColumn>,
                            <ResponsiveColumn key="header_status" xs={0} lg={0} xl={1}>
                                <div className="history-documents-list-header">{localization.text("history", "complaintStatus")}</div>
                            </ResponsiveColumn>,
                            <ResponsiveColumn className="history-documents-list-header" key="header_prd" xs={0} lg={0} xl={1}>{localization.text("history", "productNo")}</ResponsiveColumn>,
                            <ResponsiveColumn className="history-documents-list-header" key="header_prdName" xs={0} lg={0} xl={2}>{localization.text("history", "product")}</ResponsiveColumn>,
                            <ResponsiveColumn className="history-documents-list-header" key="header_epd" xs={0} lg={0} xl={1}>{localization.text("history", "epd")}</ResponsiveColumn>,
                            <ResponsiveColumn className="history-documents-list-header" key="header_qty" xs={0} lg={0} xl={1}>{localization.text("history", "claimQtySalesunits")}</ResponsiveColumn>,
                        ])}
                        {isInvoice && (
                            <ResponsiveColumn xs={2} lg={3} xl={3}>
                            </ResponsiveColumn>
                        )}
                    </ResponsiveRows>
                </div>
                <Scroll className="history-documents-scroll-area" style={{ height: listHeight }} >
                    {results.map((result, idx) => (
                        <HistoryDocumentListWrapper key={idx} result={result} localization={localization} clearClaim={clearClaim} history={history} downloadHistoryPdf={downloadHistoryPdf} isComplaintList={isComplaintList} isInvoice={isInvoice} />
                    ))}
                </Scroll>
            </div>
        );
    }
}

DocumentsList.propTypes = {
    clearDocumentsHistoryQueryResults: PropTypes.func.isRequired,
    documentsHistoryQuery: PropTypes.object.isRequired,
    documentType: PropTypes.number,
    editDocumentHistoryQuery: PropTypes.func.isRequired,
    editDocumentHistoryQueryImmediately: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    downloadHistoryPdf: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    clearClaim: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
};

export default class HistoryDocumentsComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onEditFilter = this.onEditFilter.bind(this);
        this.onEditFilterImmediately = this.onEditFilterImmediately.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.onEditTobaccoFilter = this.onEditTobaccoFilter.bind(this);
        this.onEditTobaccoFilterImmediately = this.onEditTobaccoFilterImmediately.bind(this);
        this.onScrollTobacco = this.onScrollTobacco.bind(this);
        this.calculateDocumentListHeight = this.calculateDocumentListHeight.bind(this);

        this.onTabSelected = (idx) => this.setState({
            selectedTab: idx
        });

        this.state = {
            selectedTab: 0
        };
    }

    onEditFilter(...args) {
        this.props.flowControl(async () => {
            await this.props.editDocumentHistoryQuery(...args);
        });
    }

    onEditFilterImmediately(...args) {
        this.props.flowControl(async () => {
            await this.props.editDocumentHistoryQuery(...args);
        }, 0);
    }

    onEditTobaccoFilter(...args) {
        this.props.flowControl(async () => {
            await this.props.editTobaccoDocumentsHistoryQuery(...args);
        });
    }

    onEditTobaccoFilterImmediately(...args) {
        this.props.flowControl(async () => {
            await this.props.editTobaccoDocumentsHistoryQuery(...args);
        }, 0);
    }

    onScroll(event) {
        if ((event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) < this.props.height / 3) {
            this.props.flowControl(async () => {
                await this.props.loadMoreDocumentsHistoryQueryResults();
            }, 50);
        }
    }

    onScrollTobacco(event) {
        if ((event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) < this.props.height / 3) {
            this.props.flowControl(async () => {
                await this.props.loadMoreTobaccoDocumentsHistoryQueryResults();
            }, 50);
        }
    }

    calculateDocumentListHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;

        if (deviceType !== "xs") {
            //title tab height
            productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);
        }

        //searchBar height
        productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;
        productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);

        //product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;

        return productDisplayHeight;
    }

    render() {
        const {
            clearDocumentsHistoryQueryResults,
            clearTobaccoDocumentsHistoryQueryResults,
            deviceType,
            documentsHistoryQuery,
            tobaccoDocumentsHistoryQuery,
            downloadHistoryPdf,
            localization,
            setModal,
            history,
            clearClaim,
        } = this.props;


        const documentListHeight = this.calculateDocumentListHeight();
        const listHeight = documentListHeight - 61;

        /* eslint-disable react/jsx-no-bind */
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "hidden"
            }}>
                {
                    this.state.selectedTab !== 6 ? (
                        <SearchBar
                            key="DOCUMENTS_HISTORY_SEARCH_BAR"
                            localization={localization}
                            useFilter={false}
                            filter={documentsHistoryQuery.filter}
                            onEdit={this.onEditFilter}
                            deviceType={deviceType}
                            usingSubmit={true}
                            setModal={setModal}
                        />
                    ) : (
                        <SearchBar
                            key="DOCUMENTS_TOBACCO_HISTORY_SEARCH_BAR"
                            localization={localization}
                            useFilter={false}
                            filter={tobaccoDocumentsHistoryQuery.filter}
                            onEdit={this.onEditTobaccoFilter}
                            deviceType={deviceType}
                            usingSubmit={true}
                            setModal={setModal}
                        />
                    )
                }
                <div className={"card-default"} style={{ display: "flex", flexDirection: "column", flexGrow: 1, overflow: "hidden", height: documentListHeight }}>
                    <Tabs roundCorner={deviceType !== "xs"} onTabSelected={this.onTabSelected}>
                        <TabList roundCorner={deviceType !== "xs"}>
                            <Tab label={localization.text("history", "historyTypeAllDocuments", { count: 1234 })} />
                            <Tab label={localization.text("history", "historyTypeInvoices", { count: 12 })} />
                            <Tab label={localization.text("history", "historyTypeCreditNotes", { count: 12 })} />
                            <Tab label={localization.text("history", "historyTypeComplaints", { count: 1234 })} />
                            <Tab label={localization.text("history", "historyTypeMonthReports", { count: 1234 })} />
                            <Tab label={localization.text("history", "historyTypeDeliveryNotes", { count: 1234 })} />
                            <Tab label={localization.text("history", "tobacco", { count: 1234 })} />
                        </TabList>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="ALL" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.ALL} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="INVOICES" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.INVOICES} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="CREDIT_NOTES" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.CREDIT_NOTES} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="CLAIMS" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.CLAIMS} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="MONTHLY_REPORTS" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.MONTHLY_REPORTS} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScroll}>
                            <DocumentsList key="DELIVERY_NOTES" localization={localization} editDocumentHistoryQuery={this.onEditFilter} editDocumentHistoryQueryImmediately={this.onEditFilterImmediately} clearDocumentsHistoryQueryResults={clearDocumentsHistoryQueryResults} documentsHistoryQuery={documentsHistoryQuery} documentType={HISTORY_TYPES.DELIVERY_NOTES} downloadHistoryPdf={downloadHistoryPdf} history={history} clearClaim={clearClaim} height={listHeight} />
                        </TabPanel>
                        <TabPanel overflowHidden={true} onScroll={this.onScrollTobacco}>
                            <TobaccoDocumentsList key="TOBACCO" localization={localization} editTobaccoDocumentHistoryQuery={this.onEditTobaccoFilter} editTobaccoDocumentHistoryQueryImmediately={this.onEditTobaccoFilterImmediately} clearTobaccoDocumentHistoryQueryResults={clearTobaccoDocumentsHistoryQueryResults} tobaccoDocumentsHistoryQuery={tobaccoDocumentsHistoryQuery} height={listHeight} />
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        );
        /* eslint-enable react/jsx-no-bind */
    }
}

HistoryDocumentsComponent.propTypes = {
    clearDocumentsHistoryQueryResults: PropTypes.func.isRequired,
    clearTobaccoDocumentsHistoryQueryResults: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    documentsHistoryQuery: PropTypes.object.isRequired,
    tobaccoDocumentsHistoryQuery: PropTypes.object.isRequired,
    downloadHistoryPdf: PropTypes.func.isRequired,
    editDocumentHistoryQuery: PropTypes.func.isRequired,
    editTobaccoDocumentsHistoryQuery: PropTypes.func.isRequired,
    flowControl: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    loadMoreDocumentsHistoryQueryResults: PropTypes.func.isRequired,
    loadMoreTobaccoDocumentsHistoryQueryResults: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func,
    history: PropTypes.object.isRequired,
    clearClaim: PropTypes.func.isRequired,
};
